import { gql } from "@apollo/client";

/**
 * Unit related queries and utilities
 */

export const GET_SENSORS = gql`
  query GetSensors {
    sensor {
      id
      name
    }
  }
`;
